export async function extractLastPage(pdfUrl: string) {
  console.log('Starting extractLastPage function with URL:', pdfUrl);
  try {
    // Import pdf-lib dynamically to avoid SSR issues
    const { PDFDocument } = await import('pdf-lib');

    console.log('Fetching PDF from URL');
    const response = await fetch(pdfUrl);
    console.log('Fetch response status:', response.status);
    const pdfBytes = await response.arrayBuffer();
    console.log('PDF bytes size:', pdfBytes.byteLength);

    // Load the PDF document using pdf-lib
    console.log('Loading PDF document with pdf-lib');
    const pdfDoc = await PDFDocument.load(pdfBytes);

    // Get the total number of pages
    const totalPages = pdfDoc.getPageCount();
    console.log('Total pages detected:', totalPages);

    if (totalPages === 0) {
      throw new Error('PDF document has no pages');
    }

    // Extract the last page
    console.log('Creating new PDF with only the last page');
    const newPdfDoc = await PDFDocument.create();
    const [lastPage] = await newPdfDoc.copyPages(pdfDoc, [totalPages - 1]);
    newPdfDoc.addPage(lastPage);

    // Save the new PDF with only the last page
    console.log('Serializing new PDF');
    const newPdfBytes = await newPdfDoc.save();

    // Create a blob from the new PDF bytes
    const newPdfBlob = new Blob([new Uint8Array(newPdfBytes)], {
      type: 'application/pdf',
    });
    const newPdfUrl = URL.createObjectURL(newPdfBlob);

    // Open the new PDF in a new tab
    console.log('Opening new PDF in a new tab');
    window.open(newPdfUrl, '_blank');

    // Clean up the URL object after a delay to ensure the browser has time to open it
    setTimeout(() => {
      URL.revokeObjectURL(newPdfUrl);
      console.log('Cleanup completed');
    }, 1000);
  } catch (error) {
    console.error('Error extracting last page:', error);
    console.error(
      'Error details:',
      JSON.stringify(error, Object.getOwnPropertyNames(error)),
    );
    // Fallback to opening the full PDF if extraction fails
    console.log('Falling back to opening full PDF');
    window.open(pdfUrl, '_blank');
  }
}
